import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { useIsMobile } from '../../utils';
import { RefreshProvider, useTriggerRefresh } from '../../contexts/RefreshContext';
import MobileHeader from '../Header/Mobile';
import Navigation from '../Navigation';
import {
  ExpensesPage,
  IncomePage,
  AccountsPage,
  HistoryPage,
  BudgetsPage,
  RecurringPage,
  StatisticsPage,
  MonthlyPlanPage
} from '../pages';
import ShoppingListPage from '../pages/ShoppingListPage';
import ProfilePage from '../pages/ProfilePage';
import CategoryManagement from '../pages/ProfilePage/CategoryManagement';
import GeminiOCRPage from '../pages/GeminiOCRPage';
import './MainApp.css';

const RefreshingContent: React.FC = () => (
  <div className="pull-refresh-spinner">
    <div className="spinner"></div>
  </div>
);

const PullToRefreshContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const triggerRefresh = useTriggerRefresh();
  return (
    <PullToRefresh
      onRefresh={triggerRefresh}
      pullingContent={<span className="pull-refresh-hint">↓ Потягніть для оновлення</span>}
      refreshingContent={<RefreshingContent />}
      className="pull-to-refresh"
    >
      {children}
    </PullToRefresh>
  );
};

const MainApp: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleProfileClick = (): void => {
    navigate('/dashboard/profile');
  };

  return (
    <RefreshProvider>
      <div className="main-app">
        {isMobile && <MobileHeader onProfileClick={handleProfileClick} />}

        <Navigation />

        <main className="content-area">
          <PullToRefreshContent>
            <div className="page active">
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard/expenses" replace />} />
                <Route path="/expenses" element={<ExpensesPage />} />
                <Route path="/expenses/:receiptId" element={<ShoppingListPage />} />
                <Route path="/income" element={<IncomePage />} />
                <Route path="/accounts" element={<AccountsPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/budgets" element={<BudgetsPage />} />
                <Route path="/recurring" element={<RecurringPage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/monthly-plan" element={<MonthlyPlanPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/categories" element={<CategoryManagement />} />
                <Route path="/gemini-ocr" element={<GeminiOCRPage />} />
                <Route path="*" element={<Navigate to="/dashboard/expenses" replace />} />
              </Routes>
            </div>
          </PullToRefreshContent>
        </main>
      </div>
    </RefreshProvider>
  );
};

export default MainApp;
